// Note: React Hooks for functional components
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useDebugValue, useMemo } from "react";;

export function useQuery(field, defaultValue) {
	const { search } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
        if ([undefined, null].includes(defaultValue)) return;
		if (!search.includes(field)) {
			const params = new URLSearchParams(search);
			params.set(field, defaultValue);
			navigate(`?${params.toString()}`, { replace: true });
		}
	}, []);

	const value = new URLSearchParams(search).get(field) || undefined;

    useDebugValue(value)

	return [
		useMemo(() => value, [value]),
		(newValue) => {
			const params = new URLSearchParams(search);
			if (newValue === null || newValue === undefined) {
				params.delete(field);
			} else {
				params.set(field, newValue);
			}
			navigate(`?${params.toString()}`, { replace: true });
		},
	];
}

export function useLocalStorage (field, defaultValue) {
	const [value, setValue] = useState(() => {
		const storedValue = localStorage.getItem(field);
		return storedValue !== undefined ? JSON.parse(storedValue) : defaultValue;
	});

	useEffect(() => {
		localStorage.setItem(field, JSON.stringify(value));
	}, [value]);

	useDebugValue(value)
	return [value, setValue];
}

export function useLogValue(value) {
	useDebugValue(value)
	return value;
}